import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = () => ({
	isSandbox: false,
	sandboxUrl: null,
	sandboxID: null,
});

const actions = {};

const getters = {
	getSandboxUrl: (state) => state.sandboxUrl,
	getSandboxID: (state) => state.sandboxID,
	isSandbox: (state) => state.isSandbox,
};

const mutations = {
	RESET_ALL_STATE(state) {
		state.isSandbox = false;
		state.sandboxUrl = null;
		state.sandboxID = null;
	},
	setIsSandbox(state, payload) {
		state.isSandbox = payload;
	},
	setSandboxUrl(state, payload) {
		state.sandboxUrl = payload;
	},
	setSandboxID(state, payload) {
		state.sandboxID = payload;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
